//---- components ---------
//---- mixins -------------
//---- services -----------
//---- other --------------
//
// We are lazy-loading locales. Only the default defined below will be preloaded 
//
// Available locales: de, en, es, fr, it, ja, ko, pt_BR, ru, zh_CN, zh_TW
import i18n_default from './i18n_en.json'
import i18n_custom_default from '../customers/locales/i18n_en.json'
import vee_validate_default from 'vee-validate/dist/locale/en.json'
//---- 3rd-parties --------
import merge from "lodash/merge";



let bundle = {};

// veeValidateMessages first as they should be overwritable 
if (vee_validate_default != null)
    merge(bundle, { validation: { ...vee_validate_default.messages } })

if (i18n_default != null)
    merge(bundle, i18n_default)

if (i18n_custom_default != null)
    merge(bundle, i18n_custom_default)

export const defaultLocale = 'en'
export const defaultMessages = {
  en: bundle,
}